import React from "react"
import { images } from ".."

const ChildTution = () => {
    return (
        <div className="fourth-section">
            <img src={images.dotsGreen} alt="" className="img-fluid fourth-section-img" />
            <div className="col-lg-10 col-xl-8 col-md-11 mx-auto py-5">
                <div className="row mx-0 align-items-center">
                    <div className="col-md-5">
                        <h1 className='heading'>
                            Your child's tuition
                        </h1>
                        <h1 className='heading'>
                            includes:
                        </h1>
                        <div className="points">
                            <ul>
                                <li>
                                    <span>The hottest classes and camps</span>
                                    <p className="mb-0">Summer learning from Python to Public Speaking, Leadership, AI, English and so much more.</p>
                                </li>
                                <li>
                                    <span>College prepatory courses and skill certification</span>
                                    <p className="mb-0">Meaningful recognition that boosts your child's portfolio.</p>
                                </li>
                                <li>
                                    <span>Limited Santa Clara Summer Camp T-Shirts</span>
                                    <p className="mb-0">The perfect way for students to rep their summer spirit all year long.</p>
                                </li>
                                <li>
                                    <span>Stress-free flexibility</span>
                                    <p className="mb-0">Register for your week long classes and be <br /> confident you have your summer activities all planned out.</p>
                                </li>
                                <li>
                                    <span>Each day Packed with on Campus Activities</span>
                                    <p className="mb-0">Day programs run from 9AM - 3PM.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-6 ms-md-auto">
                        <img src={images.childTution} alt="hero" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChildTution